<template>
  <loading-page v-if="loading" />

  <policies-form
    v-else
    details
    @edit="onEdit"
    @close="onClose"
  />
</template>
<script>
import PoliciesForm from './RequestPoliciesForm.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'RequestPolicyEdit',
  components: { PoliciesForm },
  data() {
    return {
      requestId: null,
    }
  },
  computed: {
    loading() {
      return this.$store.state.requestPolicies.gettingRequestPolicy
    },
  },
  created() {
    this.requestId = this.$route.params.requestId
    this.$store.dispatch('requestPolicies/getRequestPolicy', this.requestId)
      .catch(err => redirectError(err, this.$router, this.$route.path))
  },
  methods: {
    onEdit(policy) {
      this.$store.dispatch('requestPolicies/updateRequestPolicy',
        {
          id: policy.id,
          name: policy.name,
          comment: policy.comment,
          headerPolicyId: policy.headerPolicyId,
          headers: policy.headers,
          cookiePolicyId: policy.cookiePolicyId,
          cookies: policy.cookies,
          queryStringPolicyId: policy.queryStringPolicyId,
          queryStrings: policy.queryStrings,
        })
        .then(() => {
          this.successToast('Request policy was updated')
          this.onClose()
        }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating policy.') })
    },
    onClose() {
      this.$router.push({ name: 'request-policies' })
    },
  },
}
</script>
